import React from "react";

export default function SvgComponent() {
  return (
    <svg viewBox="0 0 145 145" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h145v145H0z" fill="#60b0c9" />
      <path
        d="M109.374 115.396c-4.964-9.397-36.874-15.293-36.874-15.293s-31.911 5.896-36.875 15.293C31.958 128.434 28.888 145 28.888 145h87.223c.001 0-2.071-17.763-6.737-29.604z"
        fill="#f1c9a5"
      />
      <path
        d="M72.501 100.103s31.91 5.896 36.874 15.293c4.665 11.842 6.737 29.604 6.737 29.604H72.501v-44.897z"
        fill="#e4b692"
      />
      <path d="M63.813 81.002h17.374v29.077H63.813z" fill="#f1c9a5" />
      <path d="M72.501 81.002h8.686v29.077h-8.686z" fill="#e4b692" />
      <path
        d="M63.813 94.475c1.563 4.485 7.868 7.057 12.499 7.057 1.676 0 3.306-.28 4.875-.795V81.002H63.813v13.473z"
        fill="#ddac8c"
        opacity=".1"
      />
      <path
        d="M94.837 62.652c0-18.161-10.001-28.489-22.337-28.489-12.337 0-22.338 10.328-22.338 28.489 0 18.162 10.001 32.888 22.338 32.888s22.337-14.726 22.337-32.888z"
        fill="#f1c9a5"
      />
      <path
        d="M91.438 75.245c-4.049-.451-6.783-5.088-6.098-10.353.678-5.269 4.513-9.179 8.563-8.733 4.047.449 6.777 5.084 6.094 10.353-.679 5.269-4.51 9.177-8.559 8.733z"
        fill="#e4b692"
      />
      <path
        d="M45.161 66.513c-.684-5.269 2.047-9.903 6.092-10.353 4.053-.446 7.888 3.464 8.567 8.733.683 5.265-2.053 9.901-6.1 10.353-4.049.443-7.88-3.465-8.559-8.733z"
        fill="#f1c9a5"
      />
      <path
        d="M94.837 62.652c0-18.161-10.001-28.489-22.337-28.489V95.54c12.337 0 22.337-14.726 22.337-32.888z"
        fill="#e4b692"
      />
      <path
        d="M109.374 115.396c-1.665-3.154-6.369-5.909-11.878-8.184-2.77 11.233-12.908 19.566-24.996 19.566-12.089 0-22.227-8.333-24.997-19.566-5.509 2.274-10.212 5.029-11.878 8.184C31.958 128.434 28.888 145 28.888 145h87.223c.001 0-2.071-17.763-6.737-29.604z"
        fill="#9e1f63"
      />
      <path
        d="M102.039 65.792s-12.06 6.029-20.501-10.855c-5.628.805-22.513-2.411-25.729-10.451-2.813 12.06-10.753 14.435-4.824 26.531 4.37 8.916 3.618 24.523 3.618 24.523S36.334 78.865 38.994 56.126c2.994-25.604 9.178-32.544 17.619-30.133 6.835-8.844 27.738-7.638 36.181 3.217 8.441 10.854 6.064 15.653 9.245 20.1 6.095 8.521 0 16.482 0 16.482z"
        fill="#5a3017"
      />
      <path
        d="M47.503 107.212l42.885 12.326 10.832-7.433-3.723-4.893-48.576 12.326 7.092 5.686 41.839-9.006-17.906 11.489-31.734-14.716"
        fill="none"
        stroke="#9e1f63"
        strokeWidth="1.064"
      />
      <ellipse cx="86.95" cy="81.002" fill="#5a3017" rx="16.518" ry="18.002" />
    </svg>
  );
}
